<template>

    <div v-if="enquiry!=null">
        <nav class="navbar navbar-expand navbar-primary navbar-dark">
            <!-- Left navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"  href="#" role="button">TRIP ID - {{enquiry.id}}</a>

                </li>


            </ul>

            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">
                <li class="nav-item bg-white" v-if="form.id==null">
                    <a class="nav-link text-danger" >{{ convertHMS(form.time) }}</a>
                </li>

                <li class="nav-item bg-white ml-2" v-if="form.id==null">
                    <a class="nav-link text-info"  :href="'/bestmatchingquotes?enqid='+enquiry.encryptedid" role="button">Best Matching Quotes</a>

                </li>

                <li class="nav-item bg-white ml-2" v-if="enquiry.is_hot==1">
                    <a class="nav-link text-danger"  href="#" role="button"><img style="height: 20px;" src="/images/hot.png"/> &nbsp;Hot Lead</a>

                </li>

                <li class="nav-item ml-2" v-bind:class="{ 'bg-warning': enquiry.status=='Pending' ,'bg-red':enquiry.status=='Closed','bg-success':enquiry.status=='Convered','bg-info':enquiry.status=='InProgress'}">
                    <a class="nav-link"  href="#" role="button">{{enquiry.status}}</a>

                </li>
                <li class="nav-item ml-2" >

                    <a class="nav-link btn-outline-primary"  :href="'/viewenquiry?id='+enquiry.encryptedid" role="button">BACK</a>
                </li>


            </ul>
        </nav>
        <section class="content pt-3">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-3">
                        <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                            <div class="card bg-light d-flex flex-fill">
                                <div class="card-header text-muted border-bottom-0">
                                    TRAVELER DETAIL
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2 class="lead"><b>{{enquiry.name}}</b></h2>
                                            <ul class="ml-4 mb-0 fa-ul text-muted">

                                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-phone"></i></span> Phone : {{enquiry.mobile}}</li>
                                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-envelope"></i></span> Email : {{enquiry.email_id}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                            <div class="card bg-light d-flex flex-fill">
                                <div class="card-header text-muted border-bottom-0">
                                    TRAVELER REQUIREMENT
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted"> Duration</li>
                                                <li class="small" v-if="enquiry.nights>0"> {{enquiry.nights}} Nights {{enquiry.nights+1}} Days</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Starting Date</li>
                                                <li class="small"> {{enquiry.departure_date}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Destination</li>
                                                <li class="small">{{enquiry.destinations}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Source</li>
                                                <li class="small">{{enquiry.source}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Budget</li>
                                                <li class="small">  {{enquiry.budget}} </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">No. of Travelers</li>
                                                <li class="small">  Adults -  {{enquiry.adults}} </li>
                                                <li class="small">  Childs - {{enquiry.childs}} </li>
                                                <li class="small">  Infants - {{enquiry.infants}} </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">
                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Specific Requirements</li>
                                                <li class="small">
                                                    <specific-requirements-display :text="enquiry.specific_requirements"></specific-requirements-display>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="col-md-9">
                        <form @submit.prevent="submit" >
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                                <div class="card bg-light d-flex flex-fill">
                                    <div class="card-header text-muted border-bottom-0">
                                        Basic Details
                                        <div class="card-tools">


                                        </div>
                                    </div>
                                    <div class="card-body pt-0">
                                        <div class="row">
                                            <div class="col-md-1">
                                                <div class="form-group">
                                                    <label for="nights">Nights:</label>
                                                    <input type="number" class="form-control"  id="nights" v-model="form.nights" @change="nightschange" required>
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="form-group">
                                                    <label for="days">Days:</label>
                                                    <input type="number" class="form-control"  id="days" :value="form.nights+1" readonly>
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="form-group">
                                                    <label for="days">Adults:</label>
                                                    <input type="number" class="form-control"  id="adults" v-model="form.adults" required>
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="form-group">
                                                    <label for="days">Child:</label>
                                                    <input type="number" class="form-control"  id="childs" v-model="form.childs" required>
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="form-group">
                                                    <label for="days">Infants:</label>
                                                    <input type="number" class="form-control"  id="infants" v-model="form.infants" required>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="days">Departure Date:</label>
                                                    <input type="date" class="form-control"  id="departure_date" v-model="form.departure_date" required>
                                                </div>
                                            </div>
                                            <div class="form-group col-md-5">
                                                <label>Destinations:</label>
                                                <Select2 v-model="form.destinations" :options="selected.destinations"  :settings="ajax.destinationsetting" required/>

                                            </div>
                                            </div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="form-group">

                                                    <input type="radio"  id="perpersonprice" v-model="form.price.pricetype" value="0">
                                                    <label for="perpersonprice" class="ml-2">Per Person</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">

                                                    <input type="radio" id="totalprice" v-model="form.price.pricetype" value="1">
                                                    <label for="totalprice" class="ml-2">Total</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <table class="table table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Hotel Cost
                                                            </th>
                                                            <th>
                                                                Flight Cost
                                                            </th>
                                                            <th>
                                                                Visa Cost
                                                            </th>
                                                            <th>
                                                                Land Package Cost
                                                            </th>
                                                            <th>
                                                                Cruise Cost
                                                            </th>
                                                            <th>
                                                                Travel Insurance Cost
                                                            </th>
                                                            <th>
                                                                TCS
                                                            </th>

                                                            <th>
                                                                Profit Type
                                                            </th>
                                                            <th>
                                                                Profit <span v-if="form.price.profittype==1">(%age)</span><span v-else>(Amount)</span>
                                                            </th>
                                                            <th>
                                                                GST
                                                            </th>
                                                            <th>
                                                                Quotation Price <span v-if="form.price.pricetype==0">(PP)</span><span v-else>(Total)</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"   v-model="form.price.hotel" @change="calculatequoteprice" required>
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"   v-model="form.price.flight" @change="calculatequoteprice" required>
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"   v-model="form.price.visa" @change="calculatequoteprice" required>
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"   v-model="form.price.land" @change="calculatequoteprice" required>
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"   v-model="form.price.cruise" @change="calculatequoteprice" required>
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"   v-model="form.price.travel_insurance" @change="calculatequoteprice" required>
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"   v-model="form.price.tds" @change="calculatequoteprice"  required>
                                                        </td>
                                                        <td>
                                                            <select  class="form-control form-control-sm"   v-model="form.price.profittype" @change="calculatequoteprice">
                                                                <option value="0">Amount</option>
                                                                <option value="1">Percentage</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"   v-model="form.price.profit" @change="calculatequoteprice" required>
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"    v-model="form.price.gst" readonly >
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm"    v-model="form.price.quoteprice" readonly >
                                                        </td>

                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        </div>
                                        <div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                                <div class="card bg-light d-flex flex-fill">
                                    <div class="card-header text-muted border-bottom-0">
                                        Hotel Details
                                        <div class="card-tools">
                                            <input type="checkbox" id="isnothotel" v-model="form.isnothotel"  ><label class="ml-2" for="isnothotel">Hotels Not Included</label>

                                        </div>
                                    </div>
                                    <div class="card-body pt-0" v-if="!form.isnothotel">

                                       <table class="table table-bordered table-sm mb-4" v-if="form.hotels.length>0">
                                           <thead>
                                                <tr>
                                                    <td>Nights</td>
                                                    <td>Hotel Name</td>
                                                    <td>City</td>
                                                    <td>Category</td>
                                                    <td>Room Type</td>
                                                    <td>Comments</td>
                                                    <td>Action</td>
                                                </tr>
                                           </thead>
                                           <tbody>

                                           <tr v-for="(hotel,index) in form.hotels" :key="index">
                                               <td><span v-for="(night,index1) in hotel.nights">{{night}},</span></td>
                                               <td>{{hotel.hotelname}}</td>
                                               <td>{{hotel.city}}</td>
                                               <td>{{hotel.category}}</td>
                                               <td>{{hotel.roomtype}}</td>
                                               <td>{{hotel.comments}}</td>
                                               <td>
                                                   <button type="button" class="btn btn-xs btn-info" data-toggle="modal" data-target="#modal-edithotel" @click="edithotel(index)">Edit</button>
                                                   <button type="button" class="btn btn-xs btn-danger ml-2" @click="deletehotel(index)">Delete</button>
                                               </td>
                                           </tr>
                                           </tbody>
                                       </table>


                                          <div class="row" >
                                              <div class="col-md-3">
                                                  <div class="form-group">
                                                      <label >Nights</label>
                                                      <Select2  v-model="hotelform.nights"  :options="hotelnights"
                                                                :settings="{ multiple: true,tags:true,searchable:false }"  />

                                                  </div>
                                              </div>
                                              <div class="col-md-3">
                                                  <div class="form-group">
                                                      <label >Hotel Name</label>
                                                      <input type="text" class="form-control"   v-model="hotelform.hotelname" placeholder="e.g. Taj"  >
                                                  </div>
                                              </div>
                                              <div class="col-md-2">
                                                  <div class="form-group">
                                                      <label >City</label>
                                                      <input type="text" class="form-control"   v-model="hotelform.city" placeholder="e.g. Noida"  >
                                                  </div>
                                              </div>
                                              <div class="col-md-2">
                                                  <div class="form-group">
                                                      <label >Category</label>
                                                      <input type="text" class="form-control"   v-model="hotelform.category" placeholder="e.g. 3Star"  >
                                                  </div>
                                              </div>
                                              <div class="col-md-2">
                                                  <div class="form-group">
                                                      <label >Room Type <span class="text-muted">(optional)</span> </label>
                                                      <select  class="form-control"   v-model="hotelform.roomtype"  >
                                                          <option v-for="room in roomtypes">{{room}}</option>
                                                      </select>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="row" >
                                              <div class="col-md-8">
                                                  <div class="form-group">
                                                      <label >Comments (Optional)</label>
                                                      <textarea class="form-control" v-model="hotelform.comments"></textarea>

                                                  </div>
                                              </div>
                                              <div class="col-md-4">
                                                  <button class="btn btn-primary mt-5" type="button" @click="addhotel">Add Hotel</button>
                                              </div>
                                          </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                                <div class="card bg-light d-flex flex-fill">
                                    <div class="card-header text-muted border-bottom-0">
                                        Flight
                                        <div class="card-tools">
                                            <input type="checkbox" id="isnotflight" v-model="form.isnotflight"  ><label class="ml-2" for="isnotflight">Flight Not Included</label>

                                        </div>
                                    </div>
                                    <div class="card-body pt-0" v-if="!form.isnotflight">
                                        <div class="row" v-if="form.flightdetails!=null && form.flightdetails.includes('data:image')">
                                            <div class="col-md-12 text-right">
                                                <button class="btn btn-danger btn-xs" type="button" @click="form.flightdetails=''">Remove</button>
                                            </div>
                                            <div class="col-md-12">
                                                <img :src="form.flightdetails" style="width: 100%">
                                            </div>
                                        </div>
                                        <div class="row" v-else>
                                           <div class="col-12">
                                               <div class="form-group">
                                                   <label >Flight Details
                                                   </label>
                                                   <textarea class="form-control" v-model="form.flightdetails" @paste="pasteFlight" ></textarea>
                                                   <input type="checkbox" class="mt-2" id="isrefundableflight"  v-model="form.isrefundableflight"  ><label class="ml-2" for="isrefundableflight">Refundable</label>

                                               </div>
                                           </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                                <div class="card bg-light d-flex flex-fill">
                                    <div class="card-header text-muted border-bottom-0">
                                        Detailed Day Wise Itinerary:

                                    </div>
                                    <div class="card-body pt-0" >
                                        <div class="row mt-2" v-for="(itinery,index) in form.itineraries" :key="index">
                                            <div class="col-md-2">
                                                <div class="input-group input-group-sm">
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">Day</div>
                                                    </div>
                                                    <input type="number" class="form-control form-control-sm" v-model="itinery.day"   readonly="">

                                                </div>

                                            </div>

                                            <div class="col-md-10">
                                                <input type="text" class="form-control form-control-sm"  placeholder="Title" v-model="itinery.title" required>
                                            </div>
                                            <div class="col-md-12 mt-1">
                                                <textarea type="text" class="form-control form-control-sm"  placeholder="Description" v-model="itinery.description" required/>
                                            </div>


                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                                <div class="card bg-light d-flex flex-fill">
                                    <div class="card-header text-muted border-bottom-0">
                                        Inclusions

                                    </div>
                                    <div class="card-body pt-0" >
                                        <div class="row">
                                            <div class="col-12">
                                                <Select2 v-model="form.inclusions" :options="data.inclusions"  :settings="ajax.inclusions" required/>

                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                                <div class="card bg-light d-flex flex-fill">
                                    <div class="card-header text-muted border-bottom-0">
                                        Exclusions

                                    </div>
                                    <div class="card-body pt-0" >
                                        <div class="row">
                                            <div class="col-12">
                                                <Select2 v-model="form.exclusions" :options="data.exclusions"  :settings="ajax.exclusions" required/>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="card-footer">

                                        <input type="submit" class="btn btn-primary float-right" :value="loading?'Please Wait':'Submit'" :disabled="loading">
                                    </div>

                                </div>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>



    </div>

    <div class="modal fade" id="modal-edithotel">
        <div class="modal-dialog">
            <div class="modal-content">
                <form ref="form" @submit.prevent="submitedithotel" >
                    <div class="modal-header">
                        <h4 class="modal-title">Edit Hotel</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="modaledithotelclose">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row" >
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label >Nights</label>
                                    <Select2  v-model="edithotelform.nights"  :options="hotelnights"
                                              :settings="{ multiple: true,tags:true,searchable:false }"  />

                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label >Hotel Name</label>
                                    <input type="text" class="form-control"   v-model="edithotelform.hotelname" placeholder="e.g. Taj"  >
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label >City</label>
                                    <input type="text" class="form-control"   v-model="edithotelform.city" placeholder="e.g. Noida"  >
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label >Category</label>
                                    <input type="text" class="form-control"   v-model="edithotelform.category" placeholder="e.g. 3Star"  >
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label >Room Type <span class="text-muted">(optional)</span> </label>
                                    <select  class="form-control"   v-model="edithotelform.roomtype"  >
                                        <option v-for="room in roomtypes">{{room}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row" >
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label >Comments (Optional)</label>
                                    <textarea class="form-control" v-model="edithotelform.comments"></textarea>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary" >Save</button>
                    </div>
                </form>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>



</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import SpecificRequirementsDisplay from './Enquiry/Components/SpecificRequirementsDisplay.vue';
export default {
    name: "AddQuotation",
    components: { SpecificRequirementsDisplay },
    props:['id','qid','bqid'],
    data() {
        return {
            hotelnights:[],
            interval: null,
            loading:false,
            roomtypes:[
                'Standard',
                'Super Deluxe',
                'Deluxe',
                'Luxury',
                'Duplex',
                'Executive Suite',
                'Family Suite',
                'Grande Suite',
                'Houseboat',
                'Others'
            ],
            selected:{
                destinations:[]
            },
            data:{
                inclusions:[],
                exclusions:[]
            },
            enquiry:null,
            hotelform:{
              nights:[],
              hotelname:'',
              city:'',
              category:'',
              roomtype:'',
              comments:''
            },
            edithotelform:{
                index:'',
                nights:[],
                hotelname:'',
                city:'',
                category:'',
                roomtype:'',
                comments:''
            },
            form:{
                time: 0,
                id:null,
                enquiry_id:'',
                nights:'',
                adults:'',
                childs:'',
                infants:'',
                departure_date:'',
                price:{
                    pricetype:0,
                    hotel:'',
                    flight:'',
                    visa:'',
                    land:'',
                    cruise:'',
                    travel_insurance:'',
                    tds:'',
                    profittype:0,
                    profit:'',
                    quoteprice:''
                },
                isnothotel:false,
                isnotflight:true,
                isrefundableflight:false,
                hotels:[],
                flightdetails:'',
                itineraries:[],
                destinations:[],
                inclusions:[],
                exclusions:[],
            },
            ajax:{
                destinationsetting: {
                    ajax: {
                        url: '/api/getdestinations',
                        dataType: 'json',
                        delay: 250,
                        processResults: function (data) {
                            return {
                                results: $.map(data, function (item) {
                                    return {
                                        text: item.name,
                                        id: item.id
                                    }
                                })
                            };
                        },
                        cache: true
                    },
                    multiple:true,
                    tags:true
                },
                inclusions: {


                    multiple:true,
                    tags:true
                },
                exclusions: {

                    multiple:true,
                    tags:true
                }
             }

        }
    },
    mounted() {
        this.getdata();
        this.getdetails();

        this.interval = setInterval(this.incrementTime, 1000);
    },
    methods: {
   convertHMS(value) {
        const sec = parseInt(value, 10); // convert value to number if it's string
        let hours   = Math.floor(sec / 3600); // get hours
        let minutes = Math.floor((sec - (hours * 3600)) / 60); // get minutes
        let seconds = sec - (hours * 3600) - (minutes * 60); //  get seconds
        // add 0 if value < 10; Example: 2 => 02
        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        if(hours>0){
            return hours+':'+minutes+':'+seconds;
        }
        else if(minutes>0){
            return minutes+':'+seconds;
        }
        else{
            return seconds;
        }

    },
        incrementTime() {
            this.form.time = parseInt(this.form.time) + 1;
        },
        nightschange(){
            this.loadhotelnights();

        },
        loadhotelnights(){
            var nights=[];

            for (let i = 1; i <=this.form.nights; i++) {
                nights.push({
                    text: this.ordinal(i),
                    id: i
                });
            }

            this.hotelnights=  nights;
        },
        getdata(){
            let currentObj = this;
            axios.get('/ajax/getinclusions').then(function (response) {
                currentObj.data.inclusions=response.data;

            })
                .catch(function (error) {
                });

            axios.get('/ajax/getexclusions').then(function (response) {
                currentObj.data.exclusions=response.data;

            })
                .catch(function (error) {
                });
        },
        getdetails() {

            let currentObj = this;
            axios.get('/enquirydetails?id='+this.id).then(function (response) {
                currentObj.enquiry=response.data.enquiry;
                currentObj.form.nights=currentObj.enquiry.nights;
                currentObj.form.enquiry_id=currentObj.enquiry.id;
                currentObj.form.adults=currentObj.enquiry.adults;
                currentObj.form.childs=currentObj.enquiry.childs;
                currentObj.form.infants=currentObj.enquiry.infants;

                if(currentObj.enquiry.departure_date!=""){
                    currentObj.form.departure_date=moment(currentObj.enquiry.departure_date, "DD-MM-YYYY").format('YYYY-MM-DD');
                }

                currentObj.loadhotelnights();

            })
                .catch(function (error) {
                });


            if(this.qid!="0" || this.bqid!="0"){
                var aqqid="";
                if(this.qid!="0"){
                    aqqid=this.qid;
                }
                else if(this.bqid!="0"){
                    aqqid=this.bqid;
                }
                axios.get('/quotationdetails?id='+aqqid).then(function (response) {
                    let qtn=response.data;
                    currentObj.form.nights=qtn.nights;
                    currentObj.form.adults=qtn.adults;
                    currentObj.form.childs=qtn.childs;
                    currentObj.form.infants=qtn.infants;
                    if(qtn.departure_date!=""){
                        currentObj.form.departure_date=moment(qtn.departure_date, "DD-MM-YYYY").format('YYYY-MM-DD');
                    }

                    if(currentObj.qid!="0") {
                        currentObj.form.id = qtn.id;
                    }
                    currentObj.selected.destinations=[];
                    currentObj.form.destinations=[];
                    qtn.destinations.forEach((destination, index) => {
                        currentObj.selected.destinations.push(destination);
                        currentObj.form.destinations.push(destination);
                    });
                    currentObj.form.price.pricetype=qtn.price_type;
                    currentObj.form.price.profit=parseFloat(qtn.profit);
                    currentObj.form.price.land=parseFloat(qtn.land_cost);
                    currentObj.form.price.visa=parseFloat(qtn.visa_cost);
                    currentObj.form.price.flight=parseFloat(qtn.flight_cost);
                    currentObj.form.price.cruise=parseFloat(qtn.cruise_cost);
                    currentObj.form.price.hotel=parseFloat(qtn.hotel_cost);
                    currentObj.form.price.travel_insurance=parseFloat(qtn.travel_insurance_cost);
                    currentObj.form.price.tds=parseFloat(qtn.tds_cost);
                    currentObj.form.price.quoteprice=parseFloat(qtn.quote_price);
                    currentObj.form.price.profittype=qtn.profit_type;
                    currentObj.form.price.gst=parseFloat(qtn.gst);
                    if(qtn.hotels!=null){
                        currentObj.form.hotels=qtn.hotels;
                    }

                    currentObj.form.flightdetails=qtn.flightdetails;
                    if(qtn.flight_includes==1){
                        currentObj.form.isnotflight=false;
                    }
                    else{
                        currentObj.form.isnotflight=true;
                    }

                    if(qtn.hotel_includes==1){
                        currentObj.form.isnothotel=false;
                    }
                    else{
                        currentObj.form.isnothotel=true;
                    }

                    if(qtn.isrefundableflight==1){
                        currentObj.form.isrefundableflight=true;
                    }
                    else{
                        currentObj.form.isrefundableflight=false;
                    }



                    currentObj.form.itineraries=qtn.itenaries;
                    qtn.inclusions.forEach((destination, index) => {
                        if(!currentObj.data.inclusions.includes(destination)){
                            currentObj.data.inclusions.push(destination);
                        }

                    });

                    qtn.exclusions.forEach((destination, index) => {
                        if(!currentObj.data.exclusions.includes(destination)) {
                            currentObj.data.exclusions.push(destination);
                        }

                    });

                    currentObj.form.inclusions=qtn.inclusions;
                    currentObj.form.exclusions=qtn.exclusions;
                    currentObj.loadhotelnights();

                })
                    .catch(function (error) {
                    });
            }
        },
        hotelnights(){

            var nights=[];

            for (let i = 1; i <=this.form.nights; i++) {
                nights.push({
                    text: this.ordinal(i),
                    id: i
                });
            }

            return  nights;
        },
        ordinal(num) {
            const lastDigit = num % 10;
            const lastTwoDigits = num % 100;

            return num + (
                // 11-13 take 'th'
                (lastTwoDigits > 9 && lastTwoDigits < 14) ? 'th' :
                    lastDigit === 1 ? 'st' :
                        lastDigit === 2 ? 'nd' :
                            lastDigit === 3 ? 'rd' : 'th'
            )+' Night';
        },
        calculatequoteprice(){
            var tot=parseFloat(this.form.price.travel_insurance)+parseFloat(this.form.price.cruise)+parseFloat(this.form.price.hotel)+parseFloat(this.form.price.land)+parseFloat(this.form.price.visa)+parseFloat(this.form.price.flight);

            console.log(tot);

            if(parseFloat(this.form.price.tds)>0){
                tot=tot+parseFloat(this.form.price.tds);
            }
            console.log(tot);

            if(this.form.price.profittype==0){
                var toti=parseFloat(tot)+parseFloat(this.form.price.profit);
                var gstamount=parseFloat(this.form.price.profit);
            }
            else{
                var toti=parseFloat(tot)+parseFloat((tot/100*this.form.price.profit));

                var gstamount=toti-tot;
            }

            console.log(toti);
            console.log(gstamount);

            var gst=parseFloat((gstamount/100)*18).toFixed(2);

            console.log(gst);
            this.form.price.gst=gst;

            this.form.price.quoteprice=parseFloat(toti)+parseFloat(gst);


        },
        addhotel(){

            if(this.hotelform.nights.length>0 && this.hotelform.hotelname!='' && this.hotelform.category!=''){
                this.form.hotels.push(JSON.parse(JSON.stringify(this.hotelform)));

                this.hotelform.nights=[],
                    this.hotelform.hotelname='';
                this.hotelform.city='';
                this.hotelform.category='';
                this.hotelform.roomtype='';
                this.hotelform.comments='';
            }

        },
        deletehotel(index){


            this.form.hotels.splice(index, 1);
        },
        edithotel(index){
            this.edithotelform.index=index;
            let temphotel=this.form.hotels[index];
            this.edithotelform.nights=temphotel.nights;
            this.edithotelform.hotelname=temphotel.hotelname;
            this.edithotelform.city=temphotel.city;
            this.edithotelform.category=temphotel.category;
            this.edithotelform.roomtype=temphotel.roomtype;
            this.edithotelform.comments=temphotel.comments;


        },
        submitedithotel(e){
            e.preventDefault();
            let index=this.edithotelform.index;
            this.form.hotels[index].nights=this.edithotelform.nights;
            this.form.hotels[index].hotelname=this.edithotelform.hotelname;
            this.form.hotels[index].city=this.edithotelform.city;
            this.form.hotels[index].category=this.edithotelform.category;
            this.form.hotels[index].roomtype=this.edithotelform.roomtype;
            this.form.hotels[index].comments=this.edithotelform.comments;
            this.$refs.modaledithotelclose.click();
        },
        submit(e) {
            e.preventDefault();
            let currentObj = this;
            this.loading=true;
            if(this.form.id==null){
                axios.post('/enquiry/quote/create', this.form).then(function (response) {
                    toastr.success('Quote Added Succesfully.');
                    currentObj.loading=false;
                    window.location.href='/viewenquiry?id='+currentObj.enquiry.encryptedid;

                })
                    .catch(function (error) {
                        currentObj.loading=false;
                    });
            }
            else{
                axios.post("/enquiry/quote/update", this.form).then(function (response) {
                    toastr.success('Package Edited Succesfully.');
                    currentObj.loading=false;
                    window.location.href='/viewenquiry?id='+currentObj.enquiry.encryptedid;

                })
                    .catch(function (error) {
                        currentObj.loading=false;
                    });
            }

        },
        pasteFlight(pasteEvent, callback){
            if(pasteEvent.clipboardData == false){
                if(typeof(callback) == "function"){
                    console.log('Undefined ')
                    callback(undefined);
                }
            };

            var items = pasteEvent.clipboardData.items;

            if(items == undefined){
                if(typeof(callback) == "function"){
                    callback(undefined);
                    console.log('Undefined 2')
                }
            };
            for (var i = 0; i < items.length; i++) {

                if (items[i].type.indexOf("image") == -1) continue;
                var blob = items[i].getAsFile();
                this.addImage(blob);

            }
        },
        addImage(file){
            var currentObj=this;
            if (!file.type.match('image.*')) {
                return ;
            }


            var reader = new FileReader();
            reader.onloadend = function() {
                currentObj.form.flightdetails = reader.result;
            }
            reader.readAsDataURL(file);
        }


    },
    watch: {
        'form.nights'(newvalue) {
            if(newvalue+1>this.form.itineraries.length){
                for(var x=this.form.itineraries.length+1;x<=newvalue+1;x++){
                    this.form.itineraries.push({
                        day:x,
                        title:'',
                        description:''
                    });
                }
            }
            else if(newvalue+1<this.form.itineraries.length){
                while(newvalue+1<this.form.itineraries.length){
                    this.form.itineraries.pop();
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
